import React from 'react';
import {
	List,
	Filter,
	TextInput,
	Datagrid,
	TextField,
	BooleanField,
	FunctionField,
	TopToolbar,
	CreateButton,
} from 'react-admin';
import ConfirmDeleteButton from '../../Components/Button/ConfirmDeleteBtn';
import SyncFromStripeButton from '../../Components/Button/SyncFromStripeButton';

const FeatureFilter = (props: any) => (
	<Filter {...props}>
		<TextInput label="Search" source="q" alwaysOn />
	</Filter>
);

const featureTypeColors: Record<string, string> = {
	boolean: '#4caf50',
	quantity: '#2196f3',
	enum: '#ff9800',
};

const ListActions = () => (
	<TopToolbar>
		<CreateButton />
		<SyncFromStripeButton />
	</TopToolbar>
);

export const FeatureList = (props: any) => (
	<List {...props} filters={<FeatureFilter />} exporter={false} actions={<ListActions />}>
		<Datagrid rowClick={(id) => `${id}`}>
			<TextField source="id" />
			<TextField source="slug" />
			<TextField source="name" />
			<FunctionField
				label="Type"
				render={(record: any) => (
					<span style={{ color: featureTypeColors[record.type] || '#000', fontWeight: 600 }}>
						{record.type}
					</span>
				)}
			/>
			<TextField source="stripeProductId" label="Stripe Product" />
			<BooleanField source="enabled" />
			<FunctionField
				render={(record: any) => (
					<ConfirmDeleteButton
						record={record}
						title="Delete feature"
						entity="features"
						description="Are you sure to delete this feature?"
						confirmMessage="Feature deleted"
					/>
				)}
			/>
		</Datagrid>
	</List>
);
